import contextKey from "./context-key";

export default function createContextObject(context) {
  const newContext = {};
  newContext[contextKey] = context;
  if (typeof context === "function") {
    newContext[contextKey] = undefined;
  }
  return newContext;
}
